const Header = {
  init() {
    Header.events();
    Header.toggle();
    Header.subMenu();
    Header.toggleAccessibility();
  },

  events() {
    Header.scroll();
    $(window).scroll(function () {
      Header.scroll();
    });
  },

  toggle() {
    var windowScrollTop = $(window).scrollTop();
    // toggle main navigation mobile
    $(".toggle-menu").on("click", function (e) {
      e.preventDefault();

      $(this).toggleClass("active");

      $(".header").toggleClass(
        "header--was-scrolled",
        $(".header").hasClass("header--scrolled")
      );
      if (!$(".header").hasClass("header--mobile-open"))
        windowScrollTop = $(window).scrollTop();
      $(".header").toggleClass("header--mobile-open");
      $("html").toggleClass("no-scroll");
      $("html, body").scrollTop(windowScrollTop);
    });

    // Toggle dropdown
    $(".languages__toggle").on("click", function (e) {
      e.preventDefault();
      var btn = $(this);
      btn.toggleClass("languages__toggle-open");
      btn.next().slideToggle(250);
    });
  },

  subMenu() {
    // Submenu functionality
    $(".menu-item__toggle-submenu").on("click", function (e) {
      e.preventDefault();
      var btn = $(this);
      var menuItem = btn.closest(".menu-item");
      var siblings = menuItem.siblings();

      menuItem.toggleClass("menu-item--submenu-open");
      menuItem.find(".sub-menu").slideToggle(250);

      siblings.children(".sub-menu").slideUp(250);
      siblings.removeClass("menu-item--submenu-open");

      if ($(".menu-item--submenu-open").length) {
        $("html").addClass("no-scroll");
      } else {
        $("html").addClass("no-scroll");
      }
    });
  },

  scroll() {
    var st = $(window).scrollTop();
    if (st > 110) {
      $(".header").addClass("header--scrolled");
    } else {
      $(".header").removeClass("header--scrolled");
    }
  },

  toggleAccessibility() {
    const toggleBtn = document.querySelector('.secondary-menu__btn-accessibility');
    const closeBtn = document.querySelector('.onetap-accessibility .onetap-close');
    const widget = document.querySelector('.onetap-accessibility');

    if (!widget) return;

    toggleBtn.addEventListener("click", function () {
      if (widget.classList.contains('open')) {
        widget.classList.remove('open');
      } else {
        widget.classList.add('open');
      }
    });

    closeBtn.addEventListener("click", function () {
      if (widget.classList.contains('open')) {
        widget.classList.remove('open');
      }
    })

  }
};
export default Header;
